import React from 'react';
import isNil from 'lodash/isNil';
import omitBy from 'lodash/omitBy';

import { IPageFields, IVariation } from '../../../types/contentful';

import { usePageDataContext } from '../../context/PageData';
import { getPartnerPageFooter } from '../../lib/partnerPages/getPartnerPageContent';

import { Footer2 } from '../Footer/2.0';
import { VariationContainer } from '../VariationContainer';

export function Footers({
  footerType,
  appLinkText,
  footerHeadline,
  footerPhoneDisclaimer,
  hideFooterAppLinks,
  hideFooterCta,
  pageFootnotes
}: IPageFields) {
  const { config, partnerPageConfig, slug } = usePageDataContext();

  // Use partner page footer if available, otherwise fall back to global footer
  const footer = getPartnerPageFooter({
    slug: slug || '',
    globalConfig: config,
    partnerPageConfig
  });

  const { footerDisclaimer } = config || {};

  // If page query returns 'footerType' data, show either regular Footer... or Affiliate Footer.
  const { sys, fields }: any = footerType ?? footer ?? {};

  const pageLevelFooterProps = omitBy(
    {
      appLinkText,
      footerHeadline,
      footerPhoneDisclaimer,
      hideFooterAppLinks,
      hideFooterCta,
      pageFootnotes: pageFootnotes ?? (fields as any)?.pageFootnotes,
      footerDisclaimer
    },
    isNil
  );

  switch (sys?.contentType?.sys?.id) {
    case 'variationContainer':
      // Do not lazy load
      fields?.variations?.forEach((variation: IVariation | undefined) => {
        if (variation && variation.fields?.pageBlock) {
          variation.fields.pageBlock.fields = {
            ...(variation.fields.pageBlock.fields || {}),
            ...pageLevelFooterProps
          };
        }
      });
      return <VariationContainer {...fields} sysId={sys?.id} />;

    case 'footer20':
      return <Footer2 {...fields} {...pageLevelFooterProps} />;

    default:
      return null;
  }
}
